import Categories from './Categories';
import Threads from './Threads';
import SingleThread from './SingleThread';
import ForumGuide from './ForumGuide';
import ForumRules from './ForumRules';
import ThreadView from './ThreadView';
import CreateThread from './CreateThread';

export {
    CreateThread,
    Categories,
    Threads,
    SingleThread,
    ThreadView,
    ForumGuide,
    ForumRules,
};



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/index.js